"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export const InitialEmailModalState = {
  formData: {
    selectedTemplate: null,
    excludeApplicants: false,
    delay: "None",
    subject: "",
    body: "",
    attachments: []
  },
  errors: {},
  snackbar: { message: "", state: "success" }
};
export const EmailModalReducer = (state, action) => {
  switch (action.type) {
    case "SET_FORM_DATA":
      return __spreadProps(__spreadValues({}, state), {
        formData: __spreadValues(__spreadValues({}, state.formData), action.payload),
        errors: {}
        // Clear errors when form data changes
      });
    case "SET_ERRORS":
      return __spreadProps(__spreadValues({}, state), {
        errors: __spreadValues(__spreadValues({}, state.errors), action.payload)
      });
    case "CLEAR_ERRORS":
      return __spreadProps(__spreadValues({}, state), {
        errors: {}
      });
    case "SET_SNACKBAR":
      return __spreadProps(__spreadValues({}, state), {
        snackbar: action.payload
      });
    case "RESET_FORM":
      return InitialEmailModalState;
    default:
      return state;
  }
};
